import ReceiptsLayout from 'modules/POS/Receipts';
import shopService from 'modules/shop/services';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import VerticalHeader from './Header/VerticalHeader';

const ShopLayout = () => {
  const { shop_id = '' } = useParams<{ shop_id: string }>();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(shopService.actions.initData(shop_id));
  }, []);

  return (
    <Container>
      <VerticalHeader />
      <ReceiptsLayout />
    </Container>
  );
};

export default ShopLayout;
const Container = styled.div`
  display: flex;
  height: 100%;
`;
